import { createContext } from 'react';

interface DirectToVdpContextInfo {
  isDirectToVdp?: boolean;
}

export default createContext<DirectToVdpContextInfo>({});
